export const FETCH_HIPPA_CONTENT = 'FETCH_HIPPA_CONTENT';
export const FETCH_HIPPA_CONTENT_FAILED = 'FETCH_HIPPA_CONTENT_FAILED';
export const FETCH_HIPPA_CONTENT_SUCCESS = 'FETCH_HIPPA_CONTENT_SUCCESS';
export const HIPPA_MODAL_REQUEST = 'HIPPA_MODAL_REQUEST';
export const SET_HIPPA_ATTESTATION_STATUS = 'SET_HIPPA_ATTESTATION_STATUS';